module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAYAAABy+8PSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAERJREFUeNrs0wENAAAIwzDAv+fjA1oJS9ZJCrhtJACjA0YHjA4YHTA6YHTA6IDRweiA0QGjA0YHjA4YHTA6YHT4aQUYAJK/AyEIEdX6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_front/undefined.png
// module id = o3k8
// module chunks = 0